import React from "react";
import Tabs, { Tab } from "@albertsons/uds/molecule/Tabs";
import ItemFacilityTab from "../../common/tab/InterfacesTab/ItemFacilityTab";
import "./L2Interfaces.css";
import ItemFacilityHistoryTab from "../../common/tab/InterfacesHistory/ItemFacilityHistoryTab";
import Header from "@albertsons/uds/molecule/Header";

const ItemFacility = () => {
  return (
    <div>
      <Header title="Item Facility MA NON PROD DATA Refresh"></Header>

      <div className="col-12 margin-left">
        <Tabs variant="light">
          <Tab>
            <Tab.Header>Item Facility Data Load</Tab.Header>
            <Tab.Content>
              <ItemFacilityTab />
            </Tab.Content>
          </Tab>
          <Tab>
            <Tab.Header>Item Facility History</Tab.Header>
            <Tab.Content>
              <ItemFacilityHistoryTab />
            </Tab.Content>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default ItemFacility;
